import React, { Component } from 'react';

import './Partners.scss';

import data from '../../lib/data/partners';

class Partners extends Component {

    build = () => {
        return Object.keys(data).map((key) => {
            return (
                <div className={'partner-type-container'}>
                    <span className={'partner-type-title'}>{key}</span>
                    <div className={'partner-link-container'}>
                        {data[key].map((item) => {
                            return (<a href={`${item.href}`} target="_blank" className={'partner-link'}>{item.title}</a>)
                        })}
                    </div>
                </div>
            )
        })
    }

    render() {
        // console.log(data)
        return (
            <div className={'Partners'}>
                <div className={'partners-container'}>
                    {this.build()}
                </div>
            </div>
        );
    }
}

export default Partners;